import { render, staticRenderFns } from "./FormReversal.vue?vue&type=template&id=5cd5db86"
import script from "./FormReversal.vue?vue&type=script&lang=js"
export * from "./FormReversal.vue?vue&type=script&lang=js"
import style0 from "./FormReversal.vue?vue&type=style&index=0&id=5cd5db86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports